// extracted by mini-css-extract-plugin
export var center = "ComponentTitleLockup-module--center--76e10";
export var container = "ComponentTitleLockup-module--container--1fc61";
export var full = "ComponentTitleLockup-module--full--6e2f6";
export var md = "ComponentTitleLockup-module--md--32c0d";
export var paragraph = "ComponentTitleLockup-module--paragraph--dc61c";
export var paragraphSm = "ComponentTitleLockup-module--paragraph-sm--efead";
export var paragraphXs = "ComponentTitleLockup-module--paragraph-xs--1ee5b";
export var sm = "ComponentTitleLockup-module--sm--7e002";
export var titleH1 = "ComponentTitleLockup-module--title-h1--aa696";
export var titleH1Alt = "ComponentTitleLockup-module--title-h1--alt--c4321";
export var titleH2 = "ComponentTitleLockup-module--title-h2--640d3";
export var titleH2Alt = "ComponentTitleLockup-module--title-h2--alt--9ba6c";
export var titleH3 = "ComponentTitleLockup-module--title-h3--a9f26";
export var titleH3Alt = "ComponentTitleLockup-module--title-h3--alt--ce276";
export var titleH4 = "ComponentTitleLockup-module--title-h4--f8b1c";
export var titleH4Alt = "ComponentTitleLockup-module--title-h4--alt--bd112";
export var titleH5 = "ComponentTitleLockup-module--title-h5--38f32";
export var twoColumnButton = "ComponentTitleLockup-module--two-column-button--89d30";
export var twoColumnText = "ComponentTitleLockup-module--two-column-text--b30c5";